import jwtDecode from 'jwt-decode'

export const getUserId = (): string | null => {
  const token = localStorage.getItem('authToken')
  try {
    if (token) {
      const decoded = jwtDecode<any>(token)
      return decoded.user_id
    }
    throw new Error('Try logging in again')
  } catch (error) {
    return null
  }
}

export const checkAuthorization = (): {
  status: 'ok' | 'error'
  data: {
    userId: string
    role: UserRole
    accessTokenExpired: boolean
  } | null
  error: string | undefined
} => {
  try {
    const { decoded, expired } = decodeAndCheckExpiry('authToken')
    if (expired) {
      const { expired: refreshTokenExpiry } =
        decodeAndCheckExpiry('refreshToken')
      if (refreshTokenExpiry) throw new Error('Try logging in again')
    }
    if (decoded)
      return {
        status: 'ok',
        data: {
          userId: decoded.user_id,
          role: decoded.role,
          accessTokenExpired: expired
        },
        error: undefined
      }
    return {
      status: 'error',
      data: null,
      error: undefined
    }
  } catch (error) {
    return { status: 'error', data: null, error: error.message }
  }
}

function decodeAndCheckExpiry(key: string): {
  decoded: JWTToken | null
  expired: boolean
} {
  const token = localStorage.getItem(key)
  if (token) {
    const decoded = jwtDecode<JWTToken>(token)
    let expired = false
    const expirationTime = new Date(decoded.exp * 1000)
    /* check if the token is expired */
    if (expirationTime < new Date()) {
      expired = true
    }
    return { decoded, expired }
  }
  return { decoded: null, expired: true }
}
